import { useState } from 'react';
import '@aws-amplify/ui-react/styles.css';
import { updateUserAttributes } from 'aws-amplify/auth';
import './App.css';
import { fetchCognitoUserToken } from './utils/user';
import './EditProfile.css';
import UserProfileEditor from './components/user/UserProfileEditor';
import { useThemeContext } from './contexts/BaseThemeContextProvider';

async function handleUpdateUserAttribute(
  userName,
  newUserAttributes,
  setSavedUserAttributes,
  setNewUserAttributes,
  onProfileEditorCallback,
) {
  try {
    if (!newUserAttributes.phone_number.startsWith('+1')) {
      newUserAttributes.phone_number = '+1' + newUserAttributes.phone_number;
    }
    const output = await updateUserAttributes({
      userAttributes: {
        phone_number: newUserAttributes.phone_number,
        name: newUserAttributes['name'],
        family_name: newUserAttributes['family_name'],
        'custom:address_1': newUserAttributes['custom:address_1'],
        'custom:address_2': newUserAttributes['custom:address_2'] || '',
        'custom:city': newUserAttributes['custom:city'],
        'custom:state': newUserAttributes['custom:state'],
        'custom:country': newUserAttributes['custom:country'],
        'custom:zipcode': newUserAttributes['custom:zipcode'],
        birthdate: newUserAttributes['birthdate'],
        gender: newUserAttributes['gender'],
      },
    });

    let accessToken = await fetchCognitoUserToken();
    await updateUser(userName, newUserAttributes, accessToken);

    handleUpdateUserAttributeNextSteps(output, setSavedUserAttributes, onProfileEditorCallback);

    setNewUserAttributes(newUserAttributes);
  } catch (error) {
    console.error('Error updating user attributes:', error);
    throw error;
  }
}

function handleUpdateUserAttributeNextSteps(output, setSavedUserAttributes, onProfileEditorCallback) {
  setSavedUserAttributes(true);
  onProfileEditorCallback();
}

export default function EditProfile() {
  const { cognitoUserInfo } = useThemeContext();
  const [savedUserAttributes, setSavedUserAttributes] = useState(false);
  const [newUserAttributes, setNewUserAttributes] = useState({
    ...cognitoUserInfo?.attributes,
    username: cognitoUserInfo?.currentUser?.username,
  });

  const handleCloseMessage = () => {
    setSavedUserAttributes(false);
  };

  return (
    <>
      <div id="editprofile-home">
        <UserProfileEditor
          newUserAttributes={newUserAttributes}
          setNewUserAttributes={setNewUserAttributes}
          handleUpdateUserAttribute={handleUpdateUserAttribute}
          userName={newUserAttributes?.username}
          handleCloseMessage={handleCloseMessage}
          savedUserAttributes={savedUserAttributes}
          setSavedUserAttributes={setSavedUserAttributes}
        />
      </div>
    </>
  );
}

const updateUser = async (userName, newUserAttributes, access_token) => {
  let backendUrl = process.env.REACT_APP_BACKEND_URL;
  let endpoint = `${backendUrl}/users/${userName}`;
  let request_object = {
    sub: '',
    username: userName,
    email: newUserAttributes.email,
    first_name: '',
    last_name: '',
    gender: newUserAttributes['gender'],
    birthdate: newUserAttributes['birthdate'],
    phone_number: newUserAttributes['phone_number'],
    address_1: newUserAttributes['custom:address_1'],
    address_2: newUserAttributes['custom:address_2'] || '',
    city: newUserAttributes['custom:city'],
    state: newUserAttributes['custom:state'],
    zipcode: newUserAttributes['custom:zipcode'],
    country: newUserAttributes['custom:country'],
  };
  const res = await fetch(endpoint, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json; charset=UTF-8', Authorization: 'Bearer ' + access_token },
    body: JSON.stringify(request_object),
  });

  if (!res.ok) {
    throw new Error('Failed to update user backend');
  }

  return res.json();
};
